import React from 'react';
import type { MeetingCheckTemplate } from '../types/meeting';

interface MasterPageProps {
  isOpen: boolean;
  onClose: () => void;
  templates: MeetingCheckTemplate[];
  selectedTemplateId: number | null;
  onSelectTemplate: (templateId: number) => void;
}

const MasterPage: React.FC<MasterPageProps> = ({
  isOpen,
  onClose,
  templates,
  selectedTemplateId,
  onSelectTemplate,
}) => {
  return (
    <div className={`page master-page ${isOpen ? 'active' : ''}`} id="master-page">
      <div className="page-header master-header">
        <div className="back-button material-symbols-outlined" onClick={onClose}>
          arrow_back
        </div>
        <div className="page-title master-title">MTGチェック設定</div>
      </div>
      <div className="page-content master-content">
        <div className="list template-list" id="template-list">
          {templates.map((template) => {
            const isSelected = template.id === selectedTemplateId;
            // 項目一覧をカンマ区切りで表示
            const itemsDisplay = template.items
              ?.filter((item) => item.item_text && item.item_text.trim() !== '')
              .map((item) => item.item_text)
              .join('、') || '(項目なし)';

            return (
              <div
                key={template.id}
                className={`selectable-item template-item ${isSelected ? 'selected' : ''}`}
                onClick={() => onSelectTemplate(template.id)}
              >
                <div className="template-radio" />
                <div className="template-info">
                  <div className="template-name">{template.template_name}</div>
                  <div className="template-count">{itemsDisplay}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MasterPage;

